export default class BConfig
{
	static getAccessToken()
	{
		return window._config.accessToken;
	}

	static getRoutes()
	{
		return window._config.routes;
	}

	static getRoute(key)
	{
		return this.getRoutes()[key];
	}

	static getEnergyUnit()
	{
		return window._config?.units?.ENERGY ?? "kcal";
	}
}
